import { type ChangeTeamStatusValue } from '@/api/changeTeamStatusValue.ts'

import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface PutOnHoldTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
  teamStatus: ChangeTeamStatusValue
}

export const usePutOnHoldTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, PutOnHoldTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, PutOnHoldTransportRequestApiVariables>({
    type: 'pilotePutOnHoldTransportRequest',
    ...options,
  })
